export default "__VITE_ASSET__CrrnkuzA__"